import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";
import {secretKey} from "../../env.json";
import { Encryptor } from "../../components/global/encryptor";


const { generateHmac } = Encryptor(secretKey);

const getTeeTimeBookUrl                              = '/api/teetime/getTeeTimeBook';
const getGreenFeeMasterByCalenderIDUrl               = '/api/teetime/getGreenFeeMasterByCalenderID';
const getGreenFeeMasterByDateUrl                     = '/api/teetime/getGreenFeeMasterByDate';
const getDynamicPricingAmountUrl                     = '/api/teetime/getDynamicPricingAmount';
const getCompanyMasterByRefIDUrl                     = '/api/teetime/getCompanyMasterByRefID';
const getBookingSheetUrl                             = '/api/teetime/getBookingSheet';
const getAllActiveMembersUrl                         = '/api/users/getAllActiveMembers';
const blockTeeTimeUrl                                = '/api/teetime/blockTeeTime';
const bookTeeTimeUrl                                 = '/api/teetime/bookTeeTime';
const updateTeeTimeUrl                               = '/api/teetime/updateTeeTimeBook';
const deleteTeeTimeBookUrl                           = '/api/teetime/deleteTeeTimeBook';
const releasePendingTeeTimeUrl                       = '/api/teetime/releasePendingTeeTime';
const updateSlotUrl                                  = '/api/teetime/updateSlot';

const getUsersGuestUrl                               = '/api/users/getUsersGuest';
const postUsersGuestUrl                              = '/api/users/postUsersGuest';
const postCompanyMasterUrl                           = '/api/teetime/postCompanyMaster';
const deleteUsersGuestUrl                            = '/api/users/deleteUsersGuest';
const getViewUserByIDUrl                             = '/api/users/getViewUserByID';
const getUsersGuestByRefIDUrl                        = '/api/users/getUsersGuestByRefID';

const getTeeTimeBookMemberListUrl                    = '/api/teetime/getTeeTimeBookMemberList';
const postFavouriteUserUrl                           = '/api/users/postFavouriteUser';

const getTeeTimeInitUrl                              = '/api/teetime/teeTimeInit';
const getMyTeeTimeBookingUrl                         = '/api/teetime/getMyTeeTimeBooking';
const getTeeTimeBookUserUrl                          = '/api/teetime/getTeeTimeBookUser';
const getMemberUserAllByIDUrl                        = '/api/users/getMemberUserAllByID';

// const getGreenFeeCalenderByDateUrl                   = '/api/teetime/getGreenFeeCalenderByDate';



export const getTeeTimeInit = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getTeeTimeInitUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const getTeeTimeBook = async(date) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const isWeb = true;
    const response = await axiosGet( getTeeTimeBookUrl, { headers: { auth_token: `bearer ${token}` }, params: {date, isWeb}} );
    return response;
}

export const getGreenFeeMasterByCalenderID = async(calendarId) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(getGreenFeeMasterByCalenderIDUrl,
        {
            // headers: { auth_token: `bearer ${token}` },
            headers: { auth_token: `` },
            params: { calendarId }
        });
    return response;
}

export const getDynamicPricingAmount = async(slotId, bookingDate, amount, hole) => {
    const response = await axiosGet(getDynamicPricingAmountUrl,
        {
            headers: { auth_token: `` },
            params: { slotId, bookingDate, amount, hole }
        });
    return response;
}

export const getGreenFeeMasterByDate = async(date) => {
    const response = await axiosGet(getGreenFeeMasterByDateUrl,
        {
            headers: { auth_token: `` },
            params: { date }
        });
    return response;
}

export const getCompanyMasterByRefID = async(refID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getCompanyMasterByRefIDUrl, { headers: { auth_token: `bearer ${token}` }, params: {refID}} );
    return response;
}

export const getBookingSheet = async(date) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getBookingSheetUrl, { headers: { auth_token: `bearer ${token}` }, params: {date}} );
    return response;
}

export const getAllActiveMembers = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getAllActiveMembersUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const blockTeeTime = async (book) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const encryptedData = generateHmac(book);

    const response = await axiosPost(
        blockTeeTimeUrl,
        { book },
        { headers: { auth_token: `bearer ${token}`, Authorization:  encryptedData}} 
    );
    return response;
};

export const bookTeeTime = async (teeTimeBookUser, teeTimeBook) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const response = await axiosPost(
        bookTeeTimeUrl,
        { teeTimeBookUser , teeTimeBook },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const updateTeeTime = async (users) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const response = await axiosPost(
        updateTeeTimeUrl,
        { users },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const deleteTeeTimeBook = async (id, comment) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( deleteTeeTimeBookUrl, { headers: { auth_token: `bearer ${token}` }, params: { id, comment } } );
    return response;
}

export const releasePendingTeeTime = async (ID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        releasePendingTeeTimeUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { ID }} 
    );
    return response;
};

export const getTeeTimeBookMemberList = async(userID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(getTeeTimeBookMemberListUrl, { headers: { auth_token: `bearer ${token}` } ,  params: { userID }});
    return response;
}

export const getUsersGuest = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getUsersGuestUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}


export const getUsersGuestByRefID = async (refID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getUsersGuestByRefIDUrl, { headers: { auth_token: `bearer ${token}` }, params: {refID}} );
    return response;
}

export const postUsersGuest = async (guest) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postUsersGuestUrl,
        { guest },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const updateSlot = async (book) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);

    const response = await axiosPost(
        updateSlotUrl,
        { book },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postCompanyMaster = async (companyDetails) => {
    try {
        const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postCompanyMasterUrl,
        { companyDetails },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
    } catch (error) {
        console.log(error?.response?.data?.message);
    }
};

export const deleteUsersGuest = async(id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( deleteUsersGuestUrl, { headers: { auth_token: `bearer ${token}` }, params:{ id }} );
    return response;
}

export const postFavouriteUser = async (favouriteUserID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        postFavouriteUserUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { favouriteUserID }} 
    );
    return response;
};

export const getMyTeeTimeBooking = async (userID,index, size) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(getMyTeeTimeBookingUrl, { headers: { auth_token: `bearer ${token}` }, params: { userID, index, size }});
    return response;
}

export const getTeeTimeBookUsers = async (teeTimeBookId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getTeeTimeBookUserUrl, { headers: { auth_token: `bearer ${token}` }, params:{ teeTimeBookId }} );
    return response;
}

export const getUserDetailsByID = async (userId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(getViewUserByIDUrl, { headers: { auth_token: `bearer ${token}` }, params: { userId } });
    return response;
}

export const getMemberUserAllByID = async (userId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getMemberUserAllByIDUrl, { headers: { auth_token: `bearer ${token}` }, params:{ userId }} );
    return response;
}

// export const getGreenFeeCalenderByDate = async(date) => {
//     const token = getAuthState('token');
//     if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
//     const response = await axiosGet( getGreenFeeCalenderByDateUrl, { headers: { auth_token: `bearer ${token}` }, params: {date}} );
//     return response;
// }